import Scene from '@scene';
import { setBasePlateOptions, setPedestalDimensions, setStairsDimensions, 
  setWallDimensions, setDimensionsConcreteMember } from '@reducers/selectors/dimension/actions';
import { setConcreteThickness } from '@reducers/selectors/material/actions';
import { APP_TYPES } from '@config';
import { setReinforcementWidth, /*setReinforcementDepth,*/ setReinforcementHeight } from '../reinforcement/actions';
import { mergeDeep } from '@services/helper.service';

export const SET_GROUND_WIDTH = 'SET_GROUND_WIDTH';
export const SET_GROUND_DEPTH = 'SET_GROUND_DEPTH';
export const SET_GROUND_HEIGHT = 'SET_GROUND_HEIGHT';
export const SET_GROUND_C1X = 'SET_GROUND_C1X';
export const SET_GROUND_C1Y = 'SET_GROUND_C1Y';
export const SET_GROUND_C2X = 'SET_GROUND_C2X';
export const SET_GROUND_C2Y = 'SET_GROUND_C2Y';
// export const SET_GROUND_PADDING = 'SET_GROUND_PADDING';

export const SET_PEDESTAL_PEDESTAL_DEPTH = 'SET_PEDESTAL_PEDESTAL_DEPTH';
export const SET_PEDESTAL_PEDESTAL_HEIGHT = 'SET_PEDESTAL_PEDESTAL_HEIGHT';
export const SET_PEDESTAL_FINISH_DEPTH = 'SET_PEDESTAL_FINISH_DEPTH';
export const SET_PEDESTAL_GROUND_DEPTH = 'SET_PEDESTAL_GROUND_DEPTH';

export const SET_MASONRY_TEXTURE_COLOR = 'SET_MASONRY_TEXTURE_COLOR';

export const SET_GROUND_OPTIONS = 'SET_GROUND_OPTIONS';

export const RESET_GROUND = 'RESET_GROUND';
export const SET_GROUND_STATE = 'SET_GROUND_STATE';

/*
  Action creators
 */
export function setGroundWidth(value) {
  return (dispatch, getState) => {
    if (getState().main.appType === APP_TYPES.REBAR_REINFORCEMENT){
      dispatch(setDimensionsConcreteMember({
        wa: value
      }));

      if (!getState().options.reinforcement.width.active){
        dispatch(setReinforcementWidth({value: value}));
      }
    }
    dispatch(triggerUpdate({ type: SET_GROUND_WIDTH, value }));
  };
}
export function setGroundDepth(value) {
  return (dispatch, getState) => {
    dispatch(setConcreteThickness(parseFloat(value)));
    if (getState().main.appType === APP_TYPES.REBAR_REINFORCEMENT){
      dispatch(setDimensionsConcreteMember({
        la: value 
      }));
      
      // if (!getState().options.reinforcement.depth.active){
      //   dispatch(setReinforcementDepth({value: value}));
      // }
    }
    dispatch(triggerUpdate({ type: SET_GROUND_DEPTH, value }));
  };
}
export function setGroundHeight(value) {
  return (dispatch, getState) => {
    if (getState().main.appType === APP_TYPES.REBAR_REINFORCEMENT){
      dispatch(setDimensionsConcreteMember({
        ha: value 
      }));

      if (!getState().options.reinforcement.height.active){
        dispatch(setReinforcementHeight({value: value}));
      }
    }
    dispatch(triggerUpdate({ type: SET_GROUND_HEIGHT, value }));
  };
}
export function setGroundC1x(value) {
  return (dispatch) => {
    dispatch(setBasePlateOptions({
      edgeDistance: {
        c1x: value
      }
    }));
    dispatch(triggerUpdate({ type: SET_GROUND_C1X, value }));
  };
}
export function setGroundC1y(value) {
  return (dispatch) => {
    dispatch(setBasePlateOptions({
      edgeDistance: {
        c1y: value
      }
    }));
    dispatch(triggerUpdate({ type: SET_GROUND_C1Y, value }));
  };
}
export function setGroundC2x(value) {
  return (dispatch) => { 
    dispatch(setBasePlateOptions({
      edgeDistance: {
        c2x: value || null
      }
    }));
    dispatch(triggerUpdate({ type: SET_GROUND_C2X, value }));
  };
}
export function setGroundC2y(value) {
  return (dispatch) => { 
    dispatch(setBasePlateOptions({
      edgeDistance: {
        c2y: value || null
      }
    }));
    dispatch(triggerUpdate({ type: SET_GROUND_C2Y, value }));
  };
}
// export function setGroundPadding(padding) {
//   return triggerUpdate({ type: SET_GROUND_PADDING, padding });
// }

export function setPedestalPedestalDepth(value) {
  return (dispatch) => {
    dispatch(setPedestalDimensions({ 
      h1: value
    }));
    dispatch(triggerUpdate({ type: SET_PEDESTAL_PEDESTAL_DEPTH, value }));
  };
}
export function setPedestalPedestalHeight(value) {
  return (dispatch) => {
    dispatch(setPedestalDimensions({
      w: value
    }));
    dispatch(triggerUpdate({ type: SET_PEDESTAL_PEDESTAL_HEIGHT, value }));
  };
}
export function setPedestalFinishDepth(value) {
  return (dispatch) => {
    dispatch(setPedestalDimensions({
      href: value
    }));
    dispatch(triggerUpdate({ type: SET_PEDESTAL_FINISH_DEPTH, value }));
  };
}
export function setPedestalGroundDepth(value) {
  return (dispatch) => {
    dispatch(setPedestalDimensions({
      h2: value
    }));
    dispatch(triggerUpdate({ type: SET_PEDESTAL_GROUND_DEPTH, value }));
  };
}

export function setGroundOptions(opt) {
  return (dispatch, getState) => {
    var options = mergeDeep({}, opt); // make sure we don't delete the properties from original object due to the reference
    if (options.hasOwnProperty('padding')){
      if (options.padding.hasOwnProperty('C1x')){
        dispatch(setGroundC1x(options.padding.C1x));
      }
      if (options.padding.hasOwnProperty('C2x')){
        dispatch(setGroundC2x(options.padding.C2x));        
      }
      if (options.padding.hasOwnProperty('C1y')){
        dispatch(setGroundC1y(options.padding.C1y));        
      }
      if (options.padding.hasOwnProperty('C2y')){
        dispatch(setGroundC2y(options.padding.C2y));        
      }
    }
    else if (options.hasOwnProperty('depth')){
      dispatch(setGroundDepth(options.depth));
    }
    else if (options.hasOwnProperty('height')){
      dispatch(setGroundHeight(options.height));
    }
    else if (options.hasOwnProperty('width')){
      dispatch(setGroundWidth(options.width));
    }
    else if (options.hasOwnProperty('pedestal')){
      if (options.pedestal.hasOwnProperty('pedestal')){
        if (options.pedestal.pedestal.hasOwnProperty('height')){
          dispatch(setPedestalPedestalHeight(options.pedestal.pedestal.height));
        }
        if (options.pedestal.pedestal.hasOwnProperty('depth')){
          dispatch(setPedestalPedestalDepth(options.pedestal.pedestal.depth));
        }
      }
      if (options.pedestal.hasOwnProperty('ground') && options.pedestal.ground.hasOwnProperty('depth')){
        dispatch(setPedestalGroundDepth(options.pedestal.ground.depth));
      }
      if (options.pedestal.hasOwnProperty('finish')&& options.pedestal.finish.hasOwnProperty('depth')){
        dispatch(setPedestalFinishDepth(options.pedestal.finish.depth));
      }
    }
    else if (options.hasOwnProperty('stairs')){
      let updatedStairs = {};
      if (options.stairs.hasOwnProperty('width'))
        updatedStairs.lst = options.stairs.width;
      if (options.stairs.hasOwnProperty('height'))
        updatedStairs.hst = options.stairs.height;
      if (options.stairs.hasOwnProperty('tst'))
        updatedStairs.tst = options.stairs.tst;
      dispatch(setStairsDimensions(updatedStairs));
      dispatch(triggerUpdate({ type: SET_GROUND_OPTIONS, options }));
    }
    else if (options.hasOwnProperty('walls') && options.walls.hasOwnProperty('depth')){
      dispatch(setWallDimensions({
        w: options.walls.depth
      }));
      dispatch(setGroundOptions({
        padding: {
          C1x: options.walls.depth / 2,
          C2x: options.walls.depth / 2
        }
      }));
      dispatch(triggerUpdate({ type: SET_GROUND_OPTIONS, options }));
    }
    else if (options.hasOwnProperty('masonryTextureColor')) {
      dispatch(triggerUpdate({ type: SET_MASONRY_TEXTURE_COLOR, value: options.masonryTextureColor }));
    }
    else {
      dispatch(triggerUpdate({ type: SET_GROUND_OPTIONS, options }));
    }
  };
}

export function resetGround(appType) {
  return triggerUpdate({ type: RESET_GROUND, appType });
}

export function setGroundState(state) {
	return (dispatch) => {
	  dispatch(triggerUpdate({ type: SET_GROUND_STATE, state }));
	};
}

function triggerUpdate(event) {
  return (dispatch, getState) => {
    dispatch(event);

    Scene.updateGround(getState().options.ground);
  };
}



// WEBPACK FOOTER //
// ./src/reducers/options/ground/actions.js